import React from 'react';
import { HiStar } from "react-icons/hi";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import './Trending.css';

import SwiperCore, { EffectCoverflow, Pagination } from "swiper/core";
import { TrendingData } from './Data';
import Title from '../../../../components/Title/Title';
import SubTitle from '../../../../components/SubTitle/SubTitle';


SwiperCore.use([EffectCoverflow, Pagination])

const Trending = () => {
   
    return (
        <section id="trending" className='main-trending-wrapper max-w-6xl mx-auto pt-14'>
        <SubTitle>Top Selling <span className='text-primary'>Car</span></SubTitle>
            <Title>Trending Car</Title>
            <Swiper 
            className="trending-slider mt-4"
            effect={"coverflow"}
            centeredSlides={true}
            loop={true}
            grabCursor={true}
            slidesPerView={"auto"}
            coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2.5,
                slideShadows: true,
              }}>
                {
                    TrendingData.map(data => <SwiperSlide className='trending-slide'>
                        <div className="trending-slide-image">
                        <img src={data.image} alt="" />
                        </div>
                        <div className="trending-slide-content">
                            <h1 className="car-price">{data.price}</h1>
                            <div className="trending-slide-content-bottom">
                                <h2 className='car-name'>{data.name}</h2>
                                <h3 className='car-rating'>
                                    <span>4.5</span>
                                    <div className="rating">
                                        <HiStar className='icon'/>
                                        <HiStar className='icon'/>
                                        <HiStar className='icon'/>
                                        <HiStar className='icon'/>
                                        <HiStar className='icon'/>
                                    </div>
                                </h3>
                            </div>
                        </div>
                    </SwiperSlide>)
                    
                }
              </Swiper>
        </section>
    );
};

export default Trending;